import classNames from 'classnames';
import { Link } from 'gatsby';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import isFunction from 'lodash/isFunction';
import React from 'react';

type Props = {
  title: string;
  slug?: string;
  onClick?: () => void;
  isCurrent: boolean;
  image?: IGatsbyImageData;
  jsxImage?: JSX.Element;
  borderRadius?: boolean;
  disabled?: boolean;
  noImageHeight?: number;
};

const fixWordBreak = (title = ''): string =>
  title
    .replace('Anthracite', 'Anthra<wbr>cite')
    .replace('Ultramarine', 'Ultra<wbr>marine');

export const Material: React.FC<Props> = ({
  title,
  slug,
  onClick,
  isCurrent,
  image,
  jsxImage,
  borderRadius = true,
  disabled = false,
  noImageHeight,
}): JSX.Element => {
  if (!slug && isFunction(onClick) && disabled !== true) {
    return (
      <button
        className="group flex flex-col items-center justify-center gap-2 text-center hover:no-underline"
        onClick={onClick}
      >
        {image ? (
          <GatsbyImage
            className={classNames('relative overflow-hidden', {
              'rounded-full': borderRadius,
              "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
                isCurrent,
            })}
            alt={title}
            image={image}
          />
        ) : jsxImage ? (
          <div
            className={classNames('relative overflow-hidden', {
              "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
                isCurrent,
            })}
          >
            {jsxImage}
          </div>
        ) : (
          <div
            className={classNames(
              'relative w-9 overflow-hidden rounded-full bg-black-100',
              {
                'h-9': !noImageHeight,
                "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
                  isCurrent,
              },
            )}
            style={noImageHeight ? { height: noImageHeight } : undefined}
          />
        )}

        <span
          className={classNames(
            'text-xs font-bold uppercase group-hover:text-black',
            {
              'text-black': isCurrent,
              'text-black-600': !isCurrent,
            },
          )}
          dangerouslySetInnerHTML={{
            __html: fixWordBreak(title),
          }}
        />
      </button>
    );
  }
  if (disabled === true) {
    return (
      <div className="group flex flex-col items-center justify-center gap-2 text-center opacity-50 hover:cursor-not-allowed hover:no-underline">
        {image ? (
          <GatsbyImage
            className={classNames('relative overflow-hidden', {
              'rounded-full': borderRadius,
              "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
                isCurrent,
            })}
            alt={title}
            image={image}
          />
        ) : (
          <div
            className={classNames(
              'relative w-9 overflow-hidden rounded-full bg-black-100',
              {
                'h-9': !noImageHeight,
                "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
                  isCurrent,
              },
            )}
            style={noImageHeight ? { height: noImageHeight } : undefined}
          />
        )}
        {jsxImage}
        <span
          className={classNames(
            'text-xs font-bold uppercase group-hover:text-black',
            {
              'text-black': isCurrent,
              'text-black-600': !isCurrent,
            },
          )}
          dangerouslySetInnerHTML={{
            __html: fixWordBreak(title),
          }}
        />
      </div>
    );
  }
  return (
    <Link
      to={slug}
      state={{ disableScrollUpdate: true }}
      className="group flex flex-col items-center justify-center gap-2 text-center hover:no-underline"
      replace
      aria-label={title}
    >
      {image ? (
        <GatsbyImage
          className={classNames('relative overflow-hidden', {
            'rounded-full': borderRadius,
            "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
              isCurrent,
          })}
          alt={title}
          image={image}
        />
      ) : (
        <div
          className={classNames(
            'relative w-9 overflow-hidden rounded-full bg-black-100',
            {
              'h-9': !noImageHeight,
              "after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1 after:-translate-y-1 after:rounded-full after:border after:border-black-300 after:bg-white after:content-['']":
                isCurrent,
            },
          )}
          style={noImageHeight ? { height: noImageHeight } : undefined}
        />
      )}
      {jsxImage}
      <span
        className={classNames(
          'text-xs font-bold uppercase group-hover:text-black',
          {
            'text-black': isCurrent,
            'text-black-600': !isCurrent,
          },
        )}
        dangerouslySetInnerHTML={{
          __html: fixWordBreak(title),
        }}
      />
    </Link>
  );
};
